var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
        ..._vm.buttonTypesClass,
        _vm.hasLoading ? `base-button--has-loading` : null,
        'base-button'
    ],style:(_vm.customStyle),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[(!_vm.hasLoading)?_c('span',{key:"label",staticClass:"base-button__label"},[_vm._t("icon"),_vm._t("label"),_vm._t("default")],2):_c('span',{key:"loading",staticClass:"base-button__loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }